import {SideReelFeature} from "./SideReelFeature";
import {gsap} from "gsap";
import {AnimUtils} from "../../../../utils/AnimUtils";
import {HOTB} from "../../../../HOTB";
import {GameSounds} from "../../../../sound/GameSounds";

export class MultiplierFeature extends SideReelFeature {
    constructor(rowId: number, whichSide: string, featureName: string) {
        super(rowId, whichSide, featureName);
    }

    public fireAmmo(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            this.playAnimation("4_triggerStart"),
            (): void => {
                HOTB.soundPlayer.playSideReelFeatureSounds(GameSounds.MULTIPLIER_SHOT);
            }]);

        return tl;
    }

    public getFireAmmoDuration(): number {
        return AnimUtils.getSpineDuration(this._spine, "4_triggerStart");
    }
}